import { render, staticRenderFns } from "./LogInAsSupportPage.vue?vue&type=template&id=2bc7da87&"
import script from "./LogInAsSupportPage.vue?vue&type=script&lang=js&"
export * from "./LogInAsSupportPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ccsbetaccscom/web/live/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bc7da87')) {
      api.createRecord('2bc7da87', component.options)
    } else {
      api.reload('2bc7da87', component.options)
    }
    module.hot.accept("./LogInAsSupportPage.vue?vue&type=template&id=2bc7da87&", function () {
      api.rerender('2bc7da87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/LogInAsSupportPage.vue"
export default component.exports